import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';
import React from 'react';

interface HasMessage {
  data: { message: string };
}

const isErrorWithMessage = (error: { data: unknown }): error is HasMessage => {
  if (typeof error.data !== 'object') {
    return false;
  }
  if (error.data === null) {
    return false;
  }
  if (!('message' in error.data)) {
    return false;
  }

  return typeof error.data.message === 'string';
};

const extractMessageFromError = (error?: FetchBaseQueryError | SerializedError): string => {
  if (!error) return '';
  if (!('status' in error)) {
    // error is SerializedError
    return error.message ?? `Network Error. Document deletion failed`;
  }
  if (typeof error.status === 'string') {
    return 'Network Error. Document deletion failed';
  }
  if (isErrorWithMessage(error)) {
    return error.data.message;
  }
  return `Network Error ${error.status}. Document deletion failed`;
};

export const DeleteErrorMessage: React.FC<{ error?: FetchBaseQueryError | SerializedError }> = ({ error }) => {
  const message = extractMessageFromError(error);

  return <>{message}</>;
};
